import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type DataSetConfig, type DataSetsState } from '../types';

const updateDataSetConfigCase: CaseReducer<
  DataSetsState,
  PayloadAction<{
    key: keyof Omit<DataSetsState, 'version'>;
    config: Partial<DataSetConfig>;
  }>
> = (state, action) => {
  const { config, key } = action.payload;
  state[key] = { ...state[key], ...config };

  return state;
};

export { updateDataSetConfigCase };
